import React from "react";

const SidebarSearchResults = ({ results, highlightedIndex, onResultClick, onItemHover, query }) => {
  if (!query || results.length === 0) {
    return null;
  }

  return (
    <div className="sidebar-search__results" role="listbox" aria-label="Search results">
      <div className="sidebar-search__results-heading">Search Results</div>
      {results.map((item, idx) => (
        <button
          key={idx}
          type="button"
          className={`sidebar-search__result ${highlightedIndex === idx ? "is-highlighted" : ""}`}
          onClick={() => onResultClick(item)}
          onMouseEnter={() => onItemHover(idx)}
        >
          <span className="sidebar-search__result-title">
            {item.name || item.info || item.text}
          </span>
        </button>
      ))}
    </div>
  );
};

export default SidebarSearchResults;
